export const shouldAttachSessionToken = (url = '') => {
  if (!url) return false;
  return (
    url.includes('/auth/users') ||
    url.includes('/auth/update-role') ||
    url.includes('/auth/assign-manager') ||
    url.includes('/auth/delete-user') ||
    url.includes('/departments')
  );
};
